import type {
  GlobalContextAction,
  GlobalContextReducerState
} from './reducers/types';

export interface GlobalContextProviderProps {
  children: React.ReactNode;
  initialValue?: GlobalContextReducerState;
}

export enum ContextAction {
  setLayout = 'SET_LAYOUT',
  setLang = 'SET_LANG',
  setUser = 'SET_USER',
  resetUser = 'RESET_USER',
  setRoute = 'SET_ROUTE',
  setActiveFeatureConfig = 'SET_ACTIVE_FEATURE_CONFIG'
}

export interface GlobalContextState {
  state: GlobalContextReducerState;
  dispatch: React.Dispatch<GlobalContextAction>;
}
